module.exports = __webpack_public_path__ + "static/media/session3.cecdb02d.svg";